import React from 'react';
import { Button, Modal, Space, Typography, Upload } from 'antd';
import { FileTextOutlined, UploadOutlined } from '@ant-design/icons';

import css from './ApplicationResumeModal.module.css';

const { Text } = Typography;

const ApplicationResumeModal = ({
  isOpen,
  onClose,
  selectedResume,
  resumeDisplayName,
  hasUploadedResume,
  resumeUploading,
  onUploadResume,
  onUseProfileResume,
}) => {
  const hasSelectedResume = !!selectedResume?.url;
  const selectedLabel = hasSelectedResume
    ? `${selectedResume?.source === 'applicationUpload' ? 'Uploaded resume' : 'Profile resume'}: ${resumeDisplayName || 'Resume'}`
    : 'No resume selected';

  const handleBeforeUpload = file => {
    if (typeof onUploadResume === 'function') {
      return onUploadResume(file);
    }

    return false;
  };

  return (
    <Modal
      open={isOpen}
      title={
        <div className={css.resumeModalTitleWrap}>
          <div className={css.resumeModalTitleIcon}>
            <FileTextOutlined />
          </div>
          <div className={css.resumeModalTitleTextBlock}>
            <div className={css.resumeModalTitle}>Select Resume for This Application</div>
            <div className={css.resumeModalSubtitle}>
              Use profile resume or upload one for this application.
            </div>
          </div>
        </div>
      }
      onCancel={onClose}
      width={620}
      centered
      wrapClassName={css.resumeModalWrap}
      footer={[
        <Button key="close" className={css.resumeModalCloseBtn} onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <div className={css.resumeModalContent}>
        <Text className={css.resumeModalDescription}>
          Default resume comes from your profile. Uploading here changes resume only for this application.
        </Text>

        <div className={css.resumeCurrentCard}>
          <Text className={css.resumeCurrentHeading}>Currently Selected</Text>
          <Text className={hasSelectedResume ? css.resumeCurrentValue : css.resumeCurrentValueMissing}>
            {selectedLabel}
          </Text>
        </div>

        <Space wrap className={css.resumeModalActions}>
          <Upload
            showUploadList={false}
            beforeUpload={handleBeforeUpload}
            accept=".pdf,.txt"
            maxCount={1}
          >
            <Button
              className={css.resumeUploadBtn}
              icon={<UploadOutlined />}
              loading={resumeUploading}
            >
              {hasUploadedResume ? 'Replace Uploaded Resume' : 'Upload Different Resume'}
            </Button>
          </Upload>

          {hasUploadedResume ? (
            <Button className={css.resumeUseProfileBtn} onClick={onUseProfileResume}>
              Use Profile Resume
            </Button>
          ) : null}
        </Space>
      </div>
    </Modal>
  );
};

export default ApplicationResumeModal;
